import phoneHandler from "../../../app/services/PhoneHandler";
import {post, url} from "../../../app/services/Backend/HttpRequest";

export default function DataValidator(...customRules) {
  return {
    methods: {
      async validate(data) {
        customRules.forEach(handle => this.vExtend(handle))

        this.validationRules().forEach(rule => this.$validator.attach(rule))

        await this.$validator.validateAll(data)

        return this.errors.all().length === 0
      },
      vError(field) {
        return this.errors.first(field)
      },
      vExtend(handle) {
        const extenders = {
          phone: {
            getMessage: field => '%{ field } should be a valid Swedish phone number',
            validate: value => phoneHandler.validate(value)
          },
          ssnformat: {
            getMessage: field => 'The %{ field } format is invalid',
            validate: value => {
              var nCheck = 0, nDigit = 0, bEven = false
              value = value.replace(/\D/g, "")

              for (var n = value.length - 1; n >= 0; n--) {
                var cDigit = value.charAt(n),
                  nDigit = parseInt(cDigit, 10)

                if (bEven) {
                  if ((nDigit *= 2) > 9) nDigit -= 9
                }

                nCheck += nDigit
                bEven = !bEven
              }

              return (nCheck % 10) == 0
            }
          },
          postalcodeexists: {
            getMessage: field => '%{ field } does not exist',
            validate: async value => {
              //todo - if postal code is geocoded - convert it into coordinates and send to backend here to save the geocoding quota there

              /**
               * First of all we try to validate against the locally stored Google geocoder. The reason is simple - in this case
               * the request to google is fired from the IP-address of client and with the frontend Google API key, so the
               * valuable server limit is not decreased to perform this validation
               * @type {boolean}
               */
              let exists = await this.geocoder().postalCodeExists(value)
              if(exists === true){
                return true
              }

              /**
               * If Google geocoding validation failed, then we perform the mixed validation, that happens at backend
               * in service-geocoding (using Eniro + Google)
               */
              const input = {
                url: url(this.$store.state, 'validation/postalcode'),
                payload: {postal_code: value}
              }

              const {data} = await post(input)

              return data.status
            }
          }
        }

        this.$validator.extend(handle, extenders[handle])
      }
    }
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/app/mixins/Validation/DataValidator.js